if(document.querySelector(".product form.form") && document.querySelector(".sticky_atc_main")){
    var productForm = document.querySelector(".product form.form"),
        stickyBar = document.querySelector(".sticky_atc_main"),
        stickyAtcObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if ( !entry.isIntersecting && entry.boundingClientRect.top <= 0 ) {
                        stickyBar.classList.add("active");
                    } 
                    else {
                        stickyBar.classList.remove("active");
                    }
                });
            },
            {
                threshold: 0.1
            }
        );
    
    stickyAtcObserver.observe(productForm);   
}
   
subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  var variant = event.data.variant;
  setStickyAtc(variant);
});

function setStickyAtc(variant){
    if(document.querySelector(".sticky_atc_main")){
        if(variant.available){
            document.querySelector(".sticky_atc_main .atc_js").classList.remove("disabled");
            document.querySelector(".sticky_atc_main .atc_js .text").innerHTML = window.variantStrings.addToCart;
        }else{
            document.querySelector(".sticky_atc_main .atc_js").classList.add("disabled");
            document.querySelector(".sticky_atc_main .atc_js .text").innerHTML = window.variantStrings.soldOut;
        }

        var newPrice = Shopify.formatMoney(variant.price, window.moneyFormat);
        if(document.querySelector(".sticky_atc_main .variant_price")){
            document.querySelector(".sticky_atc_main .variant_price").innerHTML = newPrice;
        }
    }
}

function getHeaderOffset() {
	let headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim().replace('px', '');
	return parseInt(headerHeight) || 0;
}

document.querySelectorAll('a[href*="#"]').forEach(function (link) {
  link.addEventListener('click', function (e) {
    let href = link.getAttribute('href');
    if (!href) return;

    let hash = href.split('#')[1];
    if (!hash) return;

    e.preventDefault();

    let target = document.getElementById(hash);

    if (target) {
      let offset = getHeaderOffset();
      let y = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({ top: y, behavior: 'smooth' });

      const url = new URL(window.location);
      url.hash = "";
      window.history.replaceState({}, "", url.toString());
	  
      return;
    }

    window.location.href = href;
  });
});